export default "__VITE_ASSET__y5N1K8y6__"